@if (!hideSafetyNotification()) {
    <ap-notification class="ap-margin-horizontal-2" status="warning">
        {{ 'conversational.chat.safety.notification' | apContent }}
    </ap-notification>
}

<div
    class="ap-flex ap-align-content-center ap-padding-horizontal-2 ap-padding-bottom-1"
    [ngClass]="hideSafetyNotification() ? 'ap-padding-vertical-1' : 'ap-padding-top-0'"
>
    <ap-chat-textarea
        [control]="inputFieldControl"
        (iconClick)="onSendChatMessage()"
        (keyup.enter)="onSendChatMessage()"
        [label]="'conversational.chat.input.field.label' | apContent"
        class="ap-width-100"
    ></ap-chat-textarea>
</div>
